import Axios from 'axios';

const WIDGET_TOKEN_KEY = 'token_widget_plataforma_digital';

export function getWidgetApiToken() {
  return localStorage.getItem(WIDGET_TOKEN_KEY);
}

export function setWidgetApiToken(token) {
  if (token) {
    localStorage.setItem(WIDGET_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(WIDGET_TOKEN_KEY);
  }
}

const createAxios = Axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
})

createAxios.interceptors.request.use((config) => {
  const token = getWidgetApiToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers.tenant = process.env.VUE_APP_TENANT;

  return config
}, (err) => {
  return Promise.reject(err)
})

createAxios.interceptors.response.use((response) => {
  return response
}, (error) => {
  return Promise.reject(error)
})

export default createAxios;